import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Typography from '@mui/material/Typography';
import PersonCard from '../components/PersonCard';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useState, useEffect } from 'react';
import { fetchDirectors } from '../strapi';
import Markdown from 'react-markdown';


function Contacts({ content, locale, info }) {
    const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://81.31.246.97:1337';
    const [directors, setDirector] = useState([]);
    useEffect(() => {
        fetchDirectors(locale)
            .then(data => {
                setDirector(data);
            })
            .catch(err => {
            });
    }, [locale]);
    let email = 'e-mail:';
    let email_v = info?.email
    let number = locale === 'ru' ? 'Телефон:' : 'Phone number:';
    let number_v = info?.num;
    let address = locale === 'ru' ? 'Адрес:' : 'Address: ';
    let address_v = info?.address;
    let title_1 = locale === 'ru' ? 'Руководство' : 'Company leadership';
    let title_2 = locale === 'ru' ? 'Реквизиты' : 'Requisites'

    return (
        <div >
            <Container>
                <Typography gutterBottom variant="h4" component="div" className='block_title'>
                    {content?.title || ''}
                </Typography>
                
                
                <Paper sx={{ m: { xs: 2, md: 4 } , p: { xs: 2, md: 4 } }}>
                            <Box >
                                <iframe
                                    src="https://yandex.ru/map-widget/v1/?ll=30.285235%2C59.896527&mode=search&oid=1014156380&ol=biz&z=17.13"
                                    width="100%"
                                    height="300px"
                                    style={{
                                        border: 0,
                                        borderRadius: '12px',
                                        width: '100%',
                                        height: '300px',
                                        display: 'block'
                                    }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Yandex Map"
                                ></iframe>
                            </Box>
                        
                            <Box sx={{ width: '100%' }}>
                                <Typography
                                    variant="h5"
                                    component="span"
                                    sx={{
                                        fontWeight: 'bold',
                                        lineHeight: { xs: '32px', md: '50px' },
                                        mr: "10px",
                                        fontSize: { xs: '16px', sm: '18px', md: '24px' }
                                    }}
                                >
                                    {email}
                                </Typography>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="span"
                                    sx={{
                                        fontSize: { xs: '16px', sm: '18px', md: '24px' }
                                    }}
                                >
                                    {email_v}
                                </Typography>
                                <br />
                                <Typography
                                    variant="h5"
                                    component="span"
                                    sx={{
                                        fontWeight: 'bold',
                                        lineHeight: { xs: '32px', md: '50px' },
                                        mr: "10px",
                                        fontSize: { xs: '16px', sm: '18px', md: '24px' }
                                    }}
                                >
                                    {number}
                                </Typography>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="span"
                                    sx={{
                                        fontSize: { xs: '16px', sm: '18px', md: '24px' }
                                    }}
                                >
                                    {number_v}
                                </Typography>
                                <br />
                                <Typography
                                    variant="h5"
                                    component="span"
                                    sx={{
                                        fontWeight: 'bold',
                                        lineHeight: { xs: '32px', md: '50px' },
                                        mr: "10px",
                                        fontSize: { xs: '16px', sm: '18px', md: '24px' }
                                    }}
                                >
                                    {address}
                                </Typography>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="span"
                                    sx={{
                                        fontSize: { xs: '16px', sm: '18px', md: '24px' }
                                    }}
                                >
                                    {address_v}
                                </Typography>
                            </Box>
                </Paper>
                <Typography gutterBottom variant="h5" component="div">
                    {title_1}
                </Typography>
                <AliceCarousel controlsStrategy="responsive, alternate" responsive={{
                    0: {
                        items: 1,
                    },
                    780: {
                        items: 2,
                        itemsFit: 'fill',
                    },
                    1280: {
                        items: 3,
                        itemsFit: 'fill',
                    },
                }}>
                    {directors != null && directors.map((item, index) =>
                        <PersonCard locale={locale} name={item.name} text={item.position} number={item.number} img={item.avatar?.url} />
                    )}
                </AliceCarousel>

                <Typography gutterBottom variant="h5" component="div" mt={2}>
                    {title_2}
                </Typography>
                <Grid container >

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Paper sx={{ p: 4, m: 2, height:'220px'}} >
                            <Markdown>
                                {content?.text || ''}
                            </Markdown>
                        </Paper>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} >
                        <Paper sx={{ p: 4, m: 2, height:'220px'}} >
                            <Markdown>
                                {(content?.someText?.[0].body) || ''}
                            </Markdown>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Contacts;
